import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimePickerComponent } from './timepicker.component';
/**
 * NgModule definition for the TimePicker component.
 */
export class TimePickerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        TimePickerComponent
    ],
    exports: [
        TimePickerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TimePickerModule_tsickle_Closure_declarations() {
/** @type {?} */
TimePickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TimePickerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
